import React from 'react';
import Config from '~/config';
import { loadAdsense } from '~/utils/file-helper';
import { device } from '~/utils';
import themeVariables from '~/shared/themeVariables';

// /17939840/Global_Illust_Side_336x280
class GoogleAds extends React.PureComponent {
  adsId = 'div-gpt-ad-1555572300636-0';

  async componentDidMount() {
    if (Config.isChina()) {
      return;
    }
    if (device.isTabletOrDesktop()) {
      this.runAds();
    } else {
      window.addEventListener('scroll', this.runAds);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.runAds);
  }

  runAds = async () => {
    window.removeEventListener('scroll', this.runAds);
    const googletag = await loadAdsense();
    if (!googletag || !googletag.cmd) return;
    googletag.cmd.push(() => {
      googletag.display(this.adsId);
    });
    googletag.cmd.push(() => {
      googletag.pubads().refresh();
    });
  };

  render() {
    if (Config.isChina()) {
      return null;
    }
    return (
      <>
        <div className="google-ads" id={this.adsId} />
        <style jsx>
          {`
            .google-ads {
              width: 400px;
              min-height: 282px;
              background: ${themeVariables.colors.lightBackground};
            }

            @media (max-width: ${themeVariables.breakpoints.mobile
                .maxWidth}px) {
              .google-ads {
                width: 100%;
              }
            }
          `}
        </style>
        <style jsx global>
          {`
            #div-gpt-ad-1555572300636-0 {
              width: 100%;
              background: #fff;
              text-align: center;
              ${Config.isIllustAC()
                ? ''
                : 'padding-top: 20px;padding-bottom: 20px;'}
            }
          `}
        </style>
      </>
    );
  }
}

export default GoogleAds;
